import {
  ContentItemMenu,
  DeleteLinkButton,
  DuplicateLinkButton,
  EditLinkButton,
  RestrictedByTooltip,
} from "components";
import { ToggleVisibilityButton } from "components/buttons/linkButtons/toggleVisibilityButton/ToggleVisibilityButton";
import { type FC, useCallback } from "react";
import { type ContentResponse } from "features/Application/services/dataServices/contentDataService";

const ENTITY_TYPE = "link";

export interface Props {
  item: ContentResponse;
  handleEdit: (id: number, isDraft: boolean) => void;
  handleDelete: (ids: number[], flowsCount?: number, packsCount?: number) => void;
  handleToggleVisibility: (ids: number[], hidden: boolean) => () => void;
  handleDuplicate: (ids: number[]) => void;
  readonly?: boolean;
  isChecked?: boolean;
  circle?: boolean;
  outlinedEllipsis?: boolean;
  hasPermission?: boolean;
  hideDisabled?: boolean;
}

export const ExternalLinksThreeDotsItemMenu: FC<Props> = (props) => {
  const {
    circle,
    outlinedEllipsis,
    readonly,
    isChecked,
    item,
    handleEdit,
    handleDelete,
    handleToggleVisibility,
    handleDuplicate,
    hideDisabled,
    hasPermission = true,
  } = props;

  const { flowsCount = 0, packsCount = 0, assignmentsCount = 0 } = item.dependencies || {};
  const dependenciesMap = { flows: flowsCount, packs: packsCount, "users or groups": assignmentsCount };
  const visibility = !hideDisabled;

  const onEditClick = useCallback(() => handleEdit(item.id, item.isDraft), [handleEdit, item.id, item.isDraft]);
  const onDeleteClick = useCallback(
    () => handleDelete([item.id], flowsCount, packsCount),
    [handleDelete, item.id, flowsCount, packsCount],
  );
  const onDuplicateClick = useCallback(() => handleDuplicate([item.id]), [handleDuplicate, item.id]);

  return (
    <RestrictedByTooltip hasPermission={hasPermission}>
      <ContentItemMenu
        circle={circle}
        outlinedEllipsis={outlinedEllipsis}
        isChecked={isChecked}
        readonly={readonly}
        dependencies={dependenciesMap}
        entityType={ENTITY_TYPE}
        item={item}
      >
        {visibility && item.hasBeenPublished && (
          <ToggleVisibilityButton
            onClick={handleToggleVisibility([item.id], !item.visibility)}
            hidden={!item.visibility}
          />
        )}
        {!item.isPurchased && <EditLinkButton onClick={onEditClick} isDisabled={item.isPurchased || readonly} />}
        {!item.isPurchased && <DuplicateLinkButton onClick={onDuplicateClick} isDisabled={readonly} />}
        {!item.isPurchased && <DeleteLinkButton onClick={onDeleteClick} isDisabled={readonly} />}
      </ContentItemMenu>
    </RestrictedByTooltip>
  );
};
